module.exports = __webpack_public_path__ + "statics/img/cate7-5@2x.eafe7527.png";